import * as types from './mutation-type.js'
// import API from '../interface/api'
import { localStorage, sessionStorage } from '../assets/javascripts/webstorage'

export default {
  [types.LOGIN] (state, data) {
    if (data) {
      state.token = data
      localStorage.set('token', data)
      // console.log('token获取成功')
    }
  },
  [types.LOGOUT] (state) {
    localStorage.removeItem('token')
    localStorage.removeItem('userinfo')
    state.token = null
    state.userinfo = {}
    // console.log('用户登出')
  },
  [types.USERINFO] (state, data) {
    state.userinfo = data
    localStorage.set('userinfo', data)
    // console.log('用户资料获取成功')
  },
  [types.SETTITLE] (state, data) {
    state.title = data
    sessionStorage.set('title', data)
  },
  [types.SAVEEXAM] (state, data) {
    state.examData = data
    sessionStorage.set('exam', data)
  },
  [types.DELETEEXAM] (state) {
    state.examData = {}
    sessionStorage.set('exam', {})
  },
  [types.SAVEQUEST] (state, data) {
    state.questData = data
    sessionStorage.set('quest', data)
  },
  [types.DELETEQUEST] (state) {
    state.questData = {}
    sessionStorage.set('quest', {})
  },
  [types.SAVEPRODUCT] (state, data) {
    state.product = data
    sessionStorage.set('product', data)
  },
  [types.DELETEPRODUCT] (state) {
    state.product = {}
    sessionStorage.set('product', {})
  },
  [types.SAVESCROLLINFO] (state, data) {
    state.scrollInfo[data.pagename] = {'status':data.status, 'scrollTop':data.scrollTop,'pageSize':data.pagesize,'pageNum':data.pagenum}
  },
  [types.DELETESCROLLINFO] (state, data) {
    state.scrollInfo[data] = null
  },
  [types.SAVECOMPETITIONID] (state, data) {
    state.competitionID = data
  },
  [types.DELETECOMPETITIONID] (state) {
    state.competitionID = {}
  }
}